import * as types from "./mutation-type";
import { API_STATES } from "@/helpers";
import { findIndex } from "lodash";

const mutations = {
  
  //fetch company and store benefit
  [types.GET_BENEFITS_BEGIN](state) {
    state.benefitsGetState = API_STATES.REQUEST_PENDING;
  },
  [types.GET_BENEFITS_SUCCESS](state, benefits) {
    state.benefitsGetError = null;
    state.benefits = benefits;
    state.benefitsGetState = API_STATES.REQUEST_SUCCESS;
  },
  [types.GET_BENEFITS_ERROR](state, err) {
    state.benefitsGetState = API_STATES.REQUEST_ERROR;
    state.benefitsGetError = err;
  },
  
  //delete benefit
  [types.DELETE_BENEFIT_BEGIN](state) {
    state.benefitDeleteState = API_STATES.REQUEST_PENDING;
  },
  [types.DELETE_BENEFIT_SUCCESS](state) {
    state.benefitDeleteError = null;
    state.benefitDeleteState = API_STATES.REQUEST_SUCCESS;
  },
  [types.DELETE_BENEFIT_ERROR](state, err) {
    state.benefitDeleteState = API_STATES.REQUEST_ERROR;
    state.benefitDeleteError = err;
  },

  //create new benefit
  [types.CREATE_BENEFIT_BEGIN](state) {
    state.benefitCreateState = API_STATES.REQUEST_PENDING
  },
  [types.CREATE_BENEFIT_SUCCESS](state, data) {
    state.benefitCreateError = null
    state.benefitCreateState = API_STATES.REQUEST_SUCCESS
    state.benefit = data
  },
  [types.CREATE_BENEFIT_ERROR](state, err) {
    state.benefitCreateState = API_STATES.REQUEST_ERROR;
    state.benefitCreateError = err;
  },

  //update benefit by its id
  [types.UPDATE_BENEFIT_BEGIN](state) {
    state.benefitUpdateState =  API_STATES.REQUEST_PENDING
  },
  [types.UPDATE_BENEFIT_SUCCESS](state, data) {
    state.benefitUpdateError = null
    state.benefit = data
    state.benefitUpdateState = API_STATES.REQUEST_SUCCESS
  },
  [types.UPDATE_BENEFIT_ERROR](state, err) {
    state.benefitUpdateState = API_STATES.REQUEST_ERROR
    state.benefitUpdateError = err
  },

  //create benefit in user_emp section
  [types.ADD_USER_BENEFIT_BEGIN](state,userId) {
    state.userBenefitUpdating.push(userId)
  },
  [types.ADD_USER_BENEFIT_SUCCESS](state, { data, rootState }) {
    const index = findIndex(state.userBenefitUpdating, data.userId);
    state.userBenefitUpdating.splice(index, 1);
    state.userBenefitUpdateError = null

    rootState.app.formData.userBenefits.push(data)
  },
  [types.ADD_USER_BENEFIT_ERROR](state, { err,userId }) {
    const index = findIndex(state.userBenefitUpdating, userId);
    state.userBenefitUpdating.splice(index, 1);
    state.userBenefitUpdateError = err;
  },

  //delete benefit in user_emp section
  [types.DELETE_USER_BENEFIT_BEGIN](state, userId) {
    state.userBenefitDeleting.push(userId);
  },
  [types.DELETE_USER_BENEFIT_SUCCESS](state, { userId, rootState }) {
    state.userBenefitDeleteError = null;
    
    const index = findIndex(rootState.app.formData.userBenefits, { userId });
    rootState.app.formData.userBenefits.splice(index, 1)

    const index2 = findIndex(state.userBenefitDeleting, userId);
    state.userBenefitDeleting.splice(index2, 1);
  },
  [types.DELETE_USER_BENEFIT_ERROR](state, { err, userId }) {
    const index = findIndex(state.userBenefitDeleting, userId);
    state.userBenefitDeleting.splice(index, 1);
    state.userBenefitDeleteError = err;
  }
};

export default mutations;
